module.exports = __webpack_public_path__ + "static/media/scottish_widow_desktop.3744c241.png";